<div
	class="card dashboard-card"
	[class.dashboard-card-featured]="featured"
>
	<div class="dashboard-card-header">
		<div class="dashboard-card-heading">
			<h4 class="dashboard-card-title">
				{{ title }}
			</h4>

			<div *ngIf="subtitle" class="dashboard-card-subtitle">
				{{ subtitle }}
			</div>
		</div>

		<div class="dashboard-card-header-actions">
			<ng-content select="[dashboardCardActions]"></ng-content>

			<div *ngIf="icon" class="dashboard-card-icon">
				<i [class]="icon"></i>
			</div>
		</div>
	</div>

	<div class="dashboard-card-content">
		<ng-content></ng-content>
	</div>
</div>
